import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { clinicianSecretaryOwnerFilterQueryOptions } from "@/features/templates/api/selectCliniciansSecretariesForOwnerFilter";
import { templateQueryOptions } from "@/features/templates/api/selectTemplates";
import { NewTemplatesPage } from "@/features/templates/components/NewTemplatesPage";

const sortValues = [
    "created_at-desc",
    "created_at-asc",
    "name-asc",
    "name-desc",
    "organisation_name-asc",
    "organisation_name-desc",
] as const;

const eventValues = ["any", "injection", "shockwave", "surgery", "education"] as const;
const statusValues = ["all", "published", "draft"] as const;

export const newTemplatesSearchSchema = z.object({
    q: z.string().catch(""),
    sort: z.enum(sortValues).catch("created_at-desc"),
    event: z.enum(eventValues).catch("any"),
    org: z.string().catch(""),
    status: z.enum(statusValues).catch("all"),
    events: z.string().catch(""), // comma-separated required_events
    substance: z.string().catch(""),
    site: z.string().catch(""),
    type: z.string().catch(""),
    area: z.string().catch(""),
    education: z.string().catch(""),
    panel: z.union([z.literal("1"), z.literal("0")]).catch("0"),
    /** Comma-separated template owner user IDs (admin) */
    owners: z.string().catch(""),
    /** Single owner (legacy); merged with owners in the UI */
    owner: z.string().catch(""),
    /** Comma-separated procedure types: injection, shockwave, surgery, education */
    evt: z.string().catch(""),
    /** Pipe-separated organisation names (URI-encoded segments) */
    orgs: z.string().catch(""),
    /** Comma-separated: published, draft */
    statuses: z.string().catch(""),
    /** Comma-separated user IDs: template people (contact and intervention roles) */
    people: z.string().catch(""),
});

export type NewTemplatesSearchT = z.infer<typeof newTemplatesSearchSchema>;

export const Route = createFileRoute("/_app/templates/")({
    component: NewTemplatesPage,
    validateSearch: (search) => newTemplatesSearchSchema.parse(search),
    loader: async ({ context }) => {
        const isAdmin = context.auth?.roles?.isAdmin || context.auth?.isSuperUser;
        await context.queryClient.ensureQueryData(templateQueryOptions(context.auth.id, isAdmin));
        if (context.auth?.roles?.isAdmin) {
            await context.queryClient.ensureQueryData(clinicianSecretaryOwnerFilterQueryOptions(context.auth.id));
        }
    },
});
